module.exports = __webpack_public_path__ + "img/WidgetRoomMockup1.ddcb8f0b.jpg";